import Vue from 'vue'
import { mapGetters } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as types from '@survey/store/types'
import * as dateutil from '@appbase/util/date-helper';

import DatePicker from '@appbase/components/DatePicker/DatePicker.vue';

@Component({
    components: {
        DatePicker
    },

    computed: mapGetters({
        pageSet: types.SURVEY_PAGESET
    })
})

export default class SurveySearchFilter extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Boolean }) isAdmin!: boolean  
    @Prop({ default:1, type: Number }) type!: number  

    pageSet!: survey.SurveyListRequest;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //   
	searchStartDate: string = '';
	searchEndDate:string = '';
    selectedStatus: number = 0
    selectedFilter: number = 0
    selectedApproval: number = 0
    keyword: string = ""
    surveyStatus: Array<any> = [
        {
            value: 0,
            text: this.$t('전체').toString()
        },
        {
            value: 2,
            text: this.$t('진행중').toString()
        },
        {
            value: 3,
            text: this.$t('종료').toString()
        }
    ]

    filter: Array<any> = [
        {
            value: 0,
            text: this.$t('제목').toString()
        },
        {
            value: 1,
            text: this.$t('설명').toString()
        },
        {
            value: 2,
            text: this.$t('작성자').toString()
        }
    ]

    approvalStatus: Array<any> = [
        {
            value: 3,
            text: this.$t('전체').toString()
        },
        {
            value: null,
            text: this.$t('승인대기중').toString()
        },
        {
            value: 1,
            text: this.$t('승인').toString()
        },
        {
            value: 0,
            text: this.$t('반려').toString()
        }
    ]

    created() {
        this.initFilter();
    }

    initFilter() {
        this.searchStartDate = this.pageSet.startDate;
        this.searchEndDate = this.pageSet.endDate;
        this.selectedStatus = this.pageSet.surveyStatus;
        this.selectedFilter = this.pageSet.filter;
        this.selectedApproval = this.pageSet.approvalStatus == null ? 3 : this.pageSet.approvalStatus;   
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    onSearch() {
        this.$emit('search', <survey.SurveyListRequest>{
            keyword: this.keyword,
            filter: this.selectedFilter,
            surveyStatus: this.selectedStatus,
            approvalStatus: this.selectedApproval,
            startDate: this.searchStartDate,
            endDate: this.searchEndDate,
            rowCount: this.pageSet.rowCount,
            pageNumber: 1,            
        })
    }
   
    //
	// ────────────────────────────────────────────────── I ──────────
	//   :::::: W A T C H : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────
	//

    @Watch("$route.query.MENUID")
    onChangedMenuId(){
		this.initFilter();
    }
}
